<template>
  <b-card no-body>
    <b-card-body>
      <taxes-detail ref="taxesDetail" type="new" :submitting="submitting" @submit="submit" />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import TaxesDetail from '@/views/pages/taxes/TaxesDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    TaxesDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService.taxesService
        .createTaxes(data)
        .then(response => {
          if (response.status) {
            this.$refs.taxesDetail.resetForm();
            this.showSuccessMessage(`${response.message}`);
            this.$router.push({ name: 'taxes' });
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
